export default function getUniqueKeys(data) {
    const uniqueKeys = Object.keys(data.reduce((prev, curr) => Object.assign(prev, curr), {})).sort();
    return uniqueKeys;
}
//# sourceMappingURL=getUniqueKeys.js.map